var render, staticRenderFns
import script from "./PsoriasisHypothesis.vue?vue&type=script&lang=js&"
export * from "./PsoriasisHypothesis.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "445e657e",
  null
  
)

export default component.exports